import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAmbulance, faWindowClose } from '@fortawesome/free-solid-svg-icons';
import { Player } from '../../../domain/entities';
import { calculateStarRating } from '../../../domain/constants';
import { RatingBadge } from '../../shared/RatingBadge';
import { PotentialBadge } from '../../shared/PotentialBadge';
import { FitnessBadge } from '../../shared/FitnessBadge';
import { MoraleBadge } from '../../shared/MoraleBadge';
import './PlayerBadgesSection.css';

interface PlayerBadgesSectionProps {
    player: Player;
    leagueAverageSkill: number;
    leagueName: string;
}

export const PlayerBadgesSection: React.FC<PlayerBadgesSectionProps> = ({
    player,
    leagueAverageSkill,
    leagueName
}) => {
    return (
        <div className="player-badges-section">
            <div className="player-badge-item">
                <div className="player-badge-label">Rating</div>
                <RatingBadge rating={calculateStarRating(player.skill + player.form, leagueAverageSkill)} leagueName={leagueName} />
            </div>

            <div className="player-badge-item">
                <div className="player-badge-label">Potential</div>
                <PotentialBadge potential={player.potential} />
            </div>

            <div className="player-badge-item">
                <div className="player-badge-label">Fitness</div>
                <FitnessBadge fitness={player.fitness} />
            </div>

            <div className="player-badge-item">
                <div className="player-badge-label">Morale</div>
                <MoraleBadge morale={player.morale} />
            </div>

            {player.injury && (
                <div className="player-badge-item player-badge-item-error">
                    <div className="player-badge-label"><FontAwesomeIcon icon={faAmbulance} style={{ marginRight: '4px' }} />{player.injury.type}</div>
                    <div className="player-badge-value">{player.injury.duration}w</div>
                </div>
            )}

            {player.suspension && (
                <div className="player-badge-item player-badge-item-error">
                    <div className="player-badge-label"><FontAwesomeIcon icon={faWindowClose} style={{ marginRight: '4px' }} />Suspended</div>
                    <div className="player-badge-value">{player.suspension.matchesRemaining}m</div>
                </div>
            )}
        </div>
    );
};
